/* FAQ (sections/faq-topic.liquid, sections/faq-excerpt.liquid). Opens the question named in the URL fragment (#<handle>) and scrolls to it,
   also when the fragment changes; «Kopier lenke» copies the full URL of the question and says «Kopiert» for a moment. Without script the
   questions still open and close (<details>) and the copy link is a plain anchor. */
(function () {
  'use strict';
  if (window.__pippeiFaq) return;
  window.__pippeiFaq = true;

  function openHash() {
    var id = decodeURIComponent((location.hash || '').slice(1));
    if (!id) return;
    var el = document.getElementById(id);
    if (!el || el.tagName !== 'DETAILS') return;
    el.open = true;
    el.scrollIntoView({ block: 'start' });
    var sum = el.querySelector('summary');
    if (sum) sum.focus({ preventScroll: true });
  }

  function copy(text, done) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done, function () {});
    }
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-faq-copy]');
    if (!a || !navigator.clipboard) return;
    e.preventDefault();
    var url = location.origin + location.pathname + a.getAttribute('href');
    copy(url, function () {
      var label = a.querySelector('span');
      if (!label) return;
      var old = label.textContent;
      label.textContent = a.getAttribute('data-label-done') || old;
      setTimeout(function () { label.textContent = old; }, 1800);
    });
    if (history.replaceState) history.replaceState(null, '', a.getAttribute('href'));
  });

  window.addEventListener('hashchange', openHash);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openHash);
  else openHash();
})();
